import { render, staticRenderFns } from "./TheUnits.vue?vue&type=template&id=412b663a&"
import script from "./TheUnits.vue?vue&type=script&lang=ts&"
export * from "./TheUnits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports